import { useEffect, useState } from 'react';
import SidebarTabs from './SidebarTabs';
import MuxPlayer from '@mux/mux-player-react';

type Project = {
  name: string;
  year?: string | number;
  location?: string;
  interiors?: string;
  awards?: string;
  about_project?: any;
  label: string;
  value: string;
  description?: { children?: { text?: string }[] }[];
  media: {
    desktop_media?: { url?: string }[];
  };
  mux_video: any;
  video: any;
};

type DetailViewProps = {
  setActiveTab: React.Dispatch<React.SetStateAction<'grid' | 'list' | 'detail' | 'video'>>;
  project: Project;
};
export default function ProjectVideo({ setActiveTab, project }: DetailViewProps) {
  const [showControlsClass, setShowControlsClass] = useState(false);
  const muxPlaybackId = project?.mux_video?.playback_id;
  const videoEnable = true;
  useEffect(() => {
    if (videoEnable) {
      setShowControlsClass(true); // ✅ Show class immediately
      const timer = setTimeout(() => {
        setShowControlsClass(false); // ✅ Remove class after 10s
      }, 10000); // 10,000ms = 10s
      return () => clearTimeout(timer);
    }
  }, [videoEnable]);
  return (
    <section className="relative min-h-screen">
      <div className="grid grid-cols-12 px-4 relative gap-2 lg:gap-5 py-5 video-player">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2 z-10 grid-mainview">
          <SidebarTabs
            setActiveTab={setActiveTab}
            activeTab="video"
            position=""
            videoControlsEnabled={true}
          />
        </div>
      </div>
      <div className="w-full max-w-6xl flex justify-center mx-auto">
        <div className="flex justify-center items-center w-full py-11 md:py-16 max-w-6xl px-4">
          <div className={showControlsClass ? 'show-controls-timer' : ''}>
            <MuxPlayer
              playbackId={muxPlaybackId}
              autoPlay
              muted={videoEnable}
              loop
              playsInline
              streamType="on-demand"
              primaryColor="#e5e1d5"
              // secondaryColor="#1d3557"
              accentColor="#b6c380"
              className={
                videoEnable
                  ? 'show-controls w-full rounded-lg shadow-lg'
                  : 'w-full rounded-lg shadow-lg'
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
}
